import { render, staticRenderFns } from "./HistoricoVouchers.vue?vue&type=template&id=fb29edd0&scoped=true"
import script from "./HistoricoVouchers.vue?vue&type=script&lang=js"
export * from "./HistoricoVouchers.vue?vue&type=script&lang=js"
import style0 from "./HistoricoVouchers.vue?vue&type=style&index=0&id=fb29edd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb29edd0",
  null
  
)

export default component.exports